const $inject = ['$window', '$scope', '$routeParams', 'dataService', '$filter', 'indexService'];

const lbaODataIndexMultiSelectCtrl = function ($window, $scope, $routeParams, dataService, $filter, indexService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
  const identifier = dataService.data.activeItem[vm.settings.searchId];
  const uri = $window[vm.settings.windowVar];

  vm.data = _.get(dataService.data.activeItem, dataLookUp) || [];
  vm.searchResults = [];
  vm.thisComp = angular.copy(vm.data);

  vm.refreshData = refreshData;
  vm.itemAdded = itemAdded;
  vm.itemRemoved = itemRemoved;

  function refreshData(userSearch) {

    indexService.search(uri, vm.settings.index, vm.settings.suggester, vm.settings.apiVersion, userSearch, vm.settings.searchFields, vm.settings.searchFields, vm.settings.valueField, identifier)
      .then((data) => {
        vm.searchResults = data.map(i => i[vm.settings.valueField]);
      });
  }

  function itemAdded($item) {
    vm.data.push($item);
    vm.thisComp = angular.copy(vm.data);
    _.set(dataService.data.activeItem, dataLookUp, vm.data);
  }

  function itemRemoved($item) {
    const copy = angular.copy(vm.data);
    const index = copy.indexOf($item[vm.settings.valueField] || $item);

    if (index > -1) {
      copy.splice(index, 1);
    }

    vm.data = copy;

    _.set(dataService.data.activeItem, dataLookUp, vm.data);
  }
};

lbaODataIndexMultiSelectCtrl.$inject = $inject;

export default lbaODataIndexMultiSelectCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaODataIndexMultiSelect/lbaODataIndexMultiSelectCtrl.js